import { useState } from 'react';
import ReactQuill from 'react-quill';
import Dialog from '../../../organisms/Dialog';

interface Props {
    isOpen: boolean;
    operationCode: string;
    loading?: boolean;
    onCancel: () => void;
    onConfirm: (reason: string) => void;
}

const DeactivateModal = ({ isOpen, operationCode, loading = false, onCancel, onConfirm }: Props) => {
    const [reason, setReason] = useState('');

    const isReasonEmpty = !reason || reason.replace(/<[^>]+>/g, '').trim().length === 0;

    const handleConfirm = () => {
        if (isReasonEmpty) return;
        onConfirm(reason);
        setReason('');
    };

    const handleCancel = () => {
        if (loading) return;
        setReason('');
        onCancel();
    };

    return (
        <Dialog
            id="deactivate-verification-config"
            show={isOpen}
            onClose={handleCancel}
            header={`Desativar verificação — ${operationCode}`}
            body={
                <div className="p-4 space-y-4">
                    <p className="text-sm text-gray-600 dark:text-gray-400">
                        Tem certeza que deseja desativar esta verificação?
                    </p>
                    <div>
                        <label className="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
                            Justificativa <span className="text-red-500">*</span>
                        </label>
                        <ReactQuill
                            value={reason}
                            onChange={setReason}
                            theme="snow"
                            placeholder="Informe o motivo da desativação..."
                            className="bg-white dark:bg-slate-700 rounded [&_.ql-editor]:min-h-[120px]"
                            modules={{ toolbar: [['bold', 'italic', 'underline'], [{ list: 'ordered' }, { list: 'bullet' }]] }}
                            readOnly={loading}
                        />
                    </div>
                </div>
            }
            footer={
                <div className="flex gap-3">
                    <button
                        onClick={handleCancel}
                        disabled={loading}
                        className="px-4 py-2 text-sm text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-slate-700 hover:bg-gray-200 dark:hover:bg-slate-600 rounded-lg transition-colors disabled:opacity-50"
                    >
                        Cancelar
                    </button>
                    <button
                        onClick={handleConfirm}
                        disabled={loading || isReasonEmpty}
                        className="px-4 py-2 text-sm text-white bg-red-600 hover:bg-red-700 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        {loading ? 'Desativando...' : 'Desativar'}
                    </button>
                </div>
            }
        />
    );
};

export default DeactivateModal;
